import apiUrl from "./config/config";
import axios from "axios";

import store from '../store/store';
import { setError } from "../slices/errorSlice";
import Global from "../Global/Global";
import { getLanguage } from "../tools/Dictionary";

class authApi {

  static value = "";

  //Sign in post
  static async signinAuth(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/signin", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

  //Refresh token 
  static async refreshAuth(params){



    try
    {
      this.setRequestHeader();

      const response = await axios.post(apiUrl + "auth/refresh", {});

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Signup post
  static async signupAuth(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/signup", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

  //Reset Password
  static async resetPassword(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/reset", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

    //Reset Password
  static async forgotPassword(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/forgot", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

    //Forgot Reset Password
  static async forgotResetPassword(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/forgot/reset", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }


  static async verifyAuth(params){

    try
    {

      const response = await axios.post(apiUrl + "auth/verify", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

  //Send verification email
  static async sendVerificationEmail(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/verify/send", params);

      return response.data;

    } catch (err)
    {


      throw new Error(err);

    }

  }

  static async getAuthGoogle(params){

    try{

      await axios(apiUrl + "auth/google");


    }catch(err){

      return err;

    }

  }


  static async redirectAuthGoogle(params)
  {

    try
    {

      const response = await axios(apiUrl + "auth/google/redirect", { params });

      return response.data;

    } catch (err)
    {

      return err;

    }

  }

  static async redirectAuthAzure(params)
  {

    try
    {

      const response = await axios(apiUrl + "auth/azure/redirect", { params });

      return response.data;

    } catch (err)
    {

      return err;

    }

  }


  static async fillAuth(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "auth/fill", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  static setRequestHeader(){

    try{
      axios.interceptors.request.use((config) =>
      {


        
        let token = localStorage.getItem(Global.apiToken);
        config.headers.Authorization = `Bearer ${token}`;
        config.headers['Expires'] = '-1';
        config.headers['Cache-Control'] = "no-cache,no-store,must-revalidate,max-age=-1,private";
        config.headers['Pragma'] = "no-cache";
        config.headers['application_id'] = Global.appId;
        config.headers['application_name'] = Global.appTitle;
        config.headers['application_version'] = Global.appVersion;
        config.headers["application_language"] = getLanguage().code;
        config.headers["application_type"] = "Web";
        return config;

      });

    }catch(err){

      throw new Error(err);

    }

    axios.interceptors.response.use(response => {

      try{

        if (response.headers["x-error"])
        {


          store.dispatch(setError(response.headers["x-error"]));


        }

        return response;

      }catch(err){

        console.log(err);

      }
      




    });



  }

}

export default authApi;
